import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSend = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M3.15 8.4V12.6875C3.15 13.3 3.85 13.5625 4.2875 13.125L6.3 10.7625L10.4125 13.825C10.7625 14.0875 11.2875 13.9125 11.375 13.475L14 0.7875C14.0875 0.2625 13.65 -0.0875004 13.125 0.0874996L0.437505 5.1625C4.97699e-06 5.3375 -0.087495 5.95 0.262505 6.3L1.6625 7.35L5.6875 5.425C6.0375 5.25 6.3 5.6875 6.0375 5.8625L3.15 8.4Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			fill: "white"
		})
	}) })]
});
export default SvgIconSend;
